import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import MVPDPicker from 'Features/SignIn/MVPDPicker';
import { handleMvpdSignIn } from 'Utils/MVPD';
import { signInMvpd } from 'State/User';
import { trackPage as segmentTrackPage, SEGMENT_EVENTS } from 'Utils/Analytics/Segment';
import { heapIdentify } from 'Utils/Analytics/Heap';
import { setBrazeUser } from 'Utils/Braze';
import NotEntitledOverlay from 'Features/SignIn/NotEntitledOverlay/index';
import { signInRedirect } from 'Utils/SignInHelpers';
import { LoadingDots } from 'Components/LoadingDots';
import { useStore } from 'Hooks/useStore';
import './MVPDContainer.css';
import { hideOverlay } from 'State/Layout';

export const MVPDContainer = () => {
  const locale = useStore('appConfig.strings');
  const { defaultConfig } = useStore('appConfig');
  const [showNotEntitled, setShowNotEntitled] = useState(false);
  const [selectedMVPD, setSelectedMVPD] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [pageTitleString, setPageTitleString] = useState('Select TV Provider');
  const [redirect, setRedirect] = useState({
    redirectPath: null,
    redirectSearch: null,
    redirectState: {},
  });
  const { entitlementId } = defaultConfig;
  const location = useLocation();

  const showNotEntitledOverlay = () => {
    setShowNotEntitled(true);
    segmentTrackPage(SEGMENT_EVENTS.noAccessLanding, window.location.pathname, 'no_access_landing');
  };

  const onMvpdSignInClick = async (mvpd) => {
    const { mvpdId, name } = mvpd;
    const signInOptions = {
      entitlementId,
      hideOverlay,
      mvpdId,
      mvpdName: name,
    };
    setSelectedMVPD({ selectedMVPD: mvpd });
    setShowLoading(true);
    setPageTitleString('Signing in to your account...');

    const { isEntitled, signInComplete, userData } = await handleMvpdSignIn(signInOptions);

    if (signInComplete) {
      const { profileId } = userData;
      heapIdentify(profileId);
      setBrazeUser(profileId);
      if (isEntitled) {
        console.debug('redirecting to web-app');
        window.localStorage.removeItem('app_closed');
        signInMvpd(userData);
        const { redirectPath, redirectSearch, redirectState } = await signInRedirect(isEntitled, location);
        setRedirect({
          redirectPath,
          redirectSearch,
          redirectState,
        });
      } else {
        setShowLoading(false);
        showNotEntitledOverlay();
      }
    } else {
      setShowLoading(false);
      showNotEntitledOverlay();
    }
  };

  const { redirectPath, redirectSearch, redirectState } = redirect;

  if (redirectPath) {
    return (
      <Navigate
        replace
        to={{
          pathname: redirectPath,
          search: redirectSearch,
        }}
        state={redirectState}
      />
    );
  }

  if (showNotEntitled) {
    return <NotEntitledOverlay selectedMVPD={selectedMVPD} />;
  }

  return (
    <CenterFrameLayout customClass="mvpdTitle" noPanel title={pageTitleString}>
      {!showLoading && (
        <div className="panel mvpd">
          <MVPDPicker withMvpds={locale.withMvpds} onMvpdSignInClick={onMvpdSignInClick}></MVPDPicker>
        </div>
      )}
      {showLoading && <LoadingDots />}
    </CenterFrameLayout>
  );
};
